var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlightsImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 436,
    height: 250,
    viewBox: "0 0 436 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 95,
    width: 436,
    height: 69,
    rx: 10,
    fill: "#F3F3F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 114,
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 126,
    width: 51,
    height: 14,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 119,
    width: 120,
    height: 14,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 138,
    width: 71,
    height: 8,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 181,
    width: 436,
    height: 69,
    rx: 10,
    fill: "#F3F3F5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 201,
    width: 32,
    height: 32,
    fill: "url(#pattern1)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 212,
    width: 51,
    height: 14,
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 206,
    width: 120,
    height: 14,
    fill: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 225,
    width: 71,
    height: 8,
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 436,
    height: 69,
    rx: 10,
    fill: "#F3F3F5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 19,
    width: 32,
    height: 32,
    fill: "url(#pattern2)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 21,
    width: 120,
    height: 14,
    fill: "#C4C4C4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 28,
    width: 51,
    height: 14,
    fill: "#C4C4C4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 40,
    width: 71,
    height: 8,
    fill: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1878_22240",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1878_22240",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_1878_22240",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1878_22240",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1878_22240",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_1878_22240",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightsImage);
export default __webpack_public_path__ + "static/media/flightsImage.1d9ec06b.svg";
export { ForwardRef as ReactComponent };